import {
  ACCEPT_COOKIES,
  API_POST,
  GET_MY,
  REQUEST_ACTIVATE,
  REQUEST_REGISTER,
  TOGGLE_FULL_WIDTH,
  UI_TOGGLE,
} from './constants';

export const toggleFullWidth = (id, toggle) => ({
  type: TOGGLE_FULL_WIDTH,
  id,
  toggle,
});

export const UIToggle = (name, value) => ({
  type: UI_TOGGLE,
  name,
  value,
});

export const register = (post, callback) => ({
  type: API_POST,
  work: REQUEST_REGISTER,
  authorized: false,
  callback,
  post,
  path: 'register',
});

// depricate
export const registerIntl = (post, callback) => ({
  type: API_POST,
  work: REQUEST_REGISTER,
  authorized: false,
  callback,
  post,
  path: 'register/intl',
});

export function activate(post, callback) {
  return {
    type: API_POST,
    gate: REQUEST_ACTIVATE,
    work: REQUEST_ACTIVATE,
    authorized: false,
    callback,
    post,
    path: 'activate',
  };
}

export function acceptCookies() {
  return {
    type: ACCEPT_COOKIES,
  };
}

export function submitContactForm(info, callback) {
  return {
    type: GET_MY,
    work: 'contact-form',
    post: {
      info,
    },
    path: 'public/submit-contact-form',
    callback,
  };
}
